import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const ResetPassword: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!password || !confirmPassword) {
      setError(t("resetPassword.enterConfirmPassword"));
      return;
    }
    if (password !== confirmPassword) {
      setError(t("resetPassword.passwordsNoMatch"));
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, newPassword: password }),
      });
      if (!res.ok) {
        const data = await res.json();
        setError(data.error || t("resetPassword.failedReset"));
      } else {
        setSuccess(t("resetPassword.resetSuccess"));
        setTimeout(() => navigate("/login"), 2500);
      }
    } catch {
      setError(t("resetPassword.failedResetRetry"));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-stone-50 p-4">
      <img src="/reviewcounter-logo.png" alt="ReviewCounter" className="w-20 h-20 object-contain mb-6" />
      <div className="bg-white rounded-xl shadow p-6 w-full max-w-md">
        <h1 className="text-xl font-bold mb-4 text-center">{t("resetPassword.title")}</h1>
        <form onSubmit={handleSubmit}>
          <label className="block mb-2 font-medium">{t("resetPassword.newPassword")}</label>
          <input
            type="password"
            className="w-full border rounded px-3 py-2 mb-4"
            value={password}
            onChange={e => setPassword(e.target.value)}
            disabled={loading}
            minLength={8}
            required
          />
          <label className="block mb-2 font-medium">{t("resetPassword.confirmNewPassword")}</label>
          <input
            type="password"
            className="w-full border rounded px-3 py-2 mb-4"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            disabled={loading}
            minLength={8}
            required
          />
          <button
            type="submit"
            className="w-full bg-teal-600 text-white py-2 rounded font-semibold mt-2 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? t("resetPassword.resetting") : t("resetPassword.reset")}
          </button>
        </form>
        {(success || error) && (
          <div className={`mt-4 text-center font-semibold ${success ? 'text-green-600' : 'text-red-600'}`}>{success || error}</div>
        )}
        <div className="mt-8 text-xs text-gray-400 text-center">
          {t("resetPassword.ignoreNote")}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword; 